// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../css-loader/dist/cjs.js??ref--6-1!../../../../postcss-loader/src/index.js!../global/variables.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".errorMessage_d8f {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: center;\n\n  max-width: 600px;\n  height: 100%;\n  margin: 0 auto;\n}\n\n.title_096 {\n  font-size: 21px;\n}\n\n.description_5be {\n  font-size: 15px;\n}\n\n.content_ee1 {\n  flex-direction: column;\n\n  color: #1f2326;\n\n  color: var(--ring-text-color);\n}\n\n.content_ee1 > .title_096,\n.description_5be {\n  margin-bottom: 16px;\n}\n\n.icon_50e {\n  margin: 0 16px 24px 0;\n\n  color: #999;\n\n  color: var(--ring-icon-secondary-color);\n}\n", ""]);
// Exports
exports.locals = {
	"errorMessage": "errorMessage_d8f",
	"title": "title_096",
	"description": "description_5be",
	"content": "content_ee1",
	"icon": "icon_50e"
};
module.exports = exports;
